/*
 * Adapted from: @ckeditor/ckeditor5-media-embed/src/mediaembedediting.js
 * The original implementation was copied and then customised to meet out specific needs
 */
export default {
	name: 'youtube',
	url: [
		/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)(?:&t=(\d+))?/,
		/^(?:m\.)?youtube\.com\/shorts\/([\w-]+)(?:\?t=(\d+))?/,
		/^(?:m\.)?youtube\.com\/v\/([\w-]+)(?:\?t=(\d+))?/,
		/^youtube\.com\/embed\/([\w-]+)(?:\?start=(\d+))?/,
		/^youtu\.be\/([\w-]+)(?:\?t=(\d+))?/,
	],
	html: (match: RegExpMatchArray) => {
		const id = match[1];
		const time = match[2];
		return (
			`<iframe src="https://www.youtube.com/embed/${id}${time ? `?start=${time}` : ''}" aria-label="video" ` +
			'frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>' +
			'</iframe>'
		);
	},
};
